// extracted by mini-css-extract-plugin
export var messageSideLeft = "_on-1";
export var stateContainer = "_on-0";